import EmbedWidget from './EmbedWidget';

export default EmbedWidget;
